import { colors } from '@/constants/colors';
import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const MedicineBallIcon: React.FC<SvgProps> = (props) => {
  const {
    width = 22,
    height = 22,
    color = colors.brand.primary,
    ...restProps
  } = props;
  return (
    <Svg
      width={width}
      height={height}
      viewBox={'0 0 24 24'}
      fill={'none'}
      {...restProps}
    >
      <Path
        d={
          'M19.076 21.22a11.605 11.605 0 004.533-8.614.374.374 0 01-.056-.01 10.69 10.69 0 01-6.041-4.214 10.69 10.69 0 01-1.887-7.266.372.372 0 01.047-.145A11.609 11.609 0 008.406.944a.37.37 0 01.067.172 10.69 10.69 0 01-1.887 7.266 10.69 10.69 0 01-6.041 4.214.375.375 0 01-.154.008 11.605 11.605 0 004.513 8.602.373.373 0 01.094-.125 10.692 10.692 0 017.033-2.626c2.635 0 5.05.951 6.917 2.527a.374.374 0 01.128.239zm-18.7-9.355a9.939 9.939 0 005.596-3.913 9.941 9.941 0 001.754-6.758V1.19C3.461 2.877.431 7.012.376 11.865zm23.246-.028c-.066-4.805-3.046-8.903-7.254-10.61a9.94 9.94 0 001.758 6.725 9.937 9.937 0 005.496 3.885zM12 17.507a5.508 5.508 0 114.607-2.488.375.375 0 01-.627-.413 4.758 4.758 0 10-1.334 1.348.375.375 0 01.418.623 5.484 5.484 0 01-3.064.93zm0 6.118a11.57 11.57 0 006.546-2.018.378.378 0 01-.081-.051 9.94 9.94 0 00-6.434-2.35A9.942 9.942 0 005.5 21.64a11.571 11.571 0 006.5 1.985z'
        }
        fill={color}
      />
    </Svg>
  );
};

export default MedicineBallIcon;
